import Icon from '../Icon';
import ButtonBase from '../UI/ButtonBase';
import Text from '../UI/Text';
import useBackButton from './hooks/useBackButton';
import { IBackButtonProps } from './types';

const BackButton: React.FC<IBackButtonProps> = ({
  title,
  fontWeight,
  sizeIcon = 16,
  fontSize = 16,
  color = '#005f47',
}) => {
  const { handleBack } = useBackButton();
  return (
    <ButtonBase
      onClick={handleBack}
      alignItems="center"
      gap={8}
      padding={6}
      borderRadius={8}
      isNotHover
    >
      <Icon size={sizeIcon} iconName="ArrowBackIosNewOutlined" />
      {title && (
        <Text color={color} fontSize={fontSize} fontWeight={fontWeight}>
          {title}
        </Text>
      )}
    </ButtonBase>
  );
};

export default BackButton;
